module.exports = __webpack_public_path__ + "static/media/ohio.15cae707.svg";